import { ISelectItem } from "winfakt-vue-components";

export enum App {
	WINFAKT_ONLINE_AUTH = "WINFAKT_ONLINE_AUTH",
	WINFAKT_MAIN_APP = "WINFAKT_MAIN_APP"
}

export function getAppSelectItems():ISelectItem<App>[]{
	return [
		{
			text: "Winfakt Online Auth",
			value: App.WINFAKT_ONLINE_AUTH
		},
		{
			text: "Winfakt Online",
			value: App.WINFAKT_MAIN_APP
		}
	];
}